const PAGARME_TOKENS_URL = 'https://api.pagar.me/core/v5/tokens'

export type PagarmeCardData = {
  number: string
  holderName: string
  expMonth: number
  expYear: number
  cvv: string
}

export class PagarmeTokenError extends Error {
  public status: number

  constructor(status: number) {
    super(`Pagar.me tokenization failed with status ${status}`)

    this.status = status
  }
}

export const createPagarmeCardToken = async (publicKey: string, card: PagarmeCardData): Promise<string> => {
  const url = new URL(PAGARME_TOKENS_URL)
  url.searchParams.set('appId', publicKey)

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      type: 'card',
      card: {
        number: card.number,
        holder_name: card.holderName,
        exp_month: card.expMonth,
        exp_year: card.expYear,
        cvv: card.cvv,
      },
    }),
  })

  if (!response.ok) {
    throw new PagarmeTokenError(response.status)
  }

  const { id } = (await response.json()) as { id: string }
  return id
}
